import React, { Component } from 'react'
import {Input, InputGroup } from 'reactstrap';
import { Link } from 'react-router-dom'
import './Login.css';
import dash from '../../assets/wordket.jpg';
import { NavItem, NavLink, Nav } from 'reactstrap';

class Login extends Component {

    constructor(props){
        super(props);
        this.state ={
            userName : "",
            password : "",
            invalid : false
        }
    }

    componentDidMount() {
        document.title = 'Login';
      }

    onLogin(){
        
        if ( this.state.userName.trim() === "wordketavenue" && this.state.password.trim() === "Axiom#2424" ){
            this.setState({ invalid : false});
            sessionStorage.setItem("loggedIn",true);
            window.location.href = "/home";
        }
        else{
            this.setState({ invalid : true});
        }
    }

    render () {
        return (
            <div>
                <div  > 
                    <NavLink style={{position:'fixed', fontSize:'30px', padding:'15px 30px', color:'white'}} tag={Link} to={'/login'}>
                            swipequotes
                            </NavLink>
                    
                </div>
                <div className='login-center'>
                    <div>
                        <div style={{display:'flex', height:'40px', borderBottom:'1px solid white'}}>
                            <div style={{width:'40px', borderRight:'1px solid white'}}>
                            </div>
                            <div>
                            </div> 
                        </div>
                        <div style={{display:'flex', height:'40px', borderBottom:'1px solid white'}}>
                            <div style={{width:'40px', borderRight:'1px solid white'}}>
                            </div>
                            <div style={{flex:1}}>
                                <input className="login-text" style={{background:'#333F50', color:'white', borderRight:'0px', borderBottom:'1px solid white', height:'40px', textIndent:'15px', width:'100%'}} type="text" placeholder="Username" onChange= {(e) => this.setState({userName : e.target.value})}/>
                            </div> 
                        </div>
                        <div style={{display:'flex', height:'40px', borderBottom:'1px solid white'}}>
                            <div style={{width:'40px', borderRight:'1px solid white'}}>
                            </div>
                            <div style={{flex:1}}>
                                <input className="login-text" style={{background:'#333F50', color:'white', borderRight:'0px', height:'40px', textIndent:'15px', width:'100%', borderBottom:'1px solid white'}} type="password" placeholder="Password" onChange= {(e) => this.setState({password : e.target.value})}/>
                            </div> 
                        </div>
                        <div style={{display:'flex', height:'40px'}}>
                            <div style={{width:'40px',  borderRight:'1px solid white'}}>
                            </div>
                            <div>
                            </div> 
                        </div>
                        <div style={{marginTop:'40px'}}>
                            <input className="loginButton" type="button" value="Sign in" onClick={() => this.onLogin()}/>
                            <div className={this.state.invalid ? 'showErrorMessage' : 'hideErrorMessage'} style={{color:'white',marginTop:'5px'}}>Username or Password incorrect</div>
                        </div>
                        
                    </div>            
                </div>
                <div className='login-footer'>
                    <Nav horizontal className="list-unstyled pb-3">
                        <NavItem>
                            <NavLink tag={Link} to={'/login'}>
                            Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/aboutUs'}>
                            About Us
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/termsOfService'}>
                            Terms of Service
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/privacyPolicy'}>
                            Privacy & Content Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/questions'}>
                            Have Questions ?
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/connect'}>
                            Connect with Us
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
            </div>
            
        )
    }
}

export default Login 